import { JourneysProvider } from "../context/journeys-context";
import JourneysController from "./journeys-controller";
import HomepageController from "./homepage-controller";
import { PropTypes } from "base/react-libs";

const JourneysHomeController = ({ entryPoint }) => {
  return <JourneysProvider>{entryPoint === "home" ? <HomepageController /> : <JourneysController />}</JourneysProvider>;
};

JourneysHomeController.propTypes = {
  entryPoint: PropTypes.string,
};

export default JourneysHomeController;
